import { useState } from "react";


function CounterTwo () {
    const [count, setCount] = useState(0);

    const increment = () => {
        setCount(count + 1);
    }

    // const decrement = () => {
    //     setCount(count - 1);
    // } can use decreeent or setCount stuff any one. 

    const reset = () => {
         setCount(0);
    };

    return (
        <section>
            <h2>Function Component with Use State</h2>
            <div className="counter">
                <input type="button" value="Minus" onClick={() => setCount(count - 1)}/>
                <input type="text" value={count} readOnly />
                <input type="button" value="Plus" onClick={increment}/>
                <input type="button" value='Reset' onClick={reset} />
            </div>
        </section>
    );
}

export default CounterTwo;